/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeneratorExternalKey } from './GeneratorExternalKey';
import {
    GeneratorExternalKeyFromJSON,
    GeneratorExternalKeyFromJSONTyped,
    GeneratorExternalKeyToJSON,
    GeneratorExternalKeyToJSONTyped,
} from './GeneratorExternalKey';
import type { Sensor } from './Sensor';
import {
    SensorFromJSON,
    SensorFromJSONTyped,
    SensorToJSON,
    SensorToJSONTyped,
} from './Sensor';

/**
 * 
 * @export
 * @interface ReImportSpecification
 */
export interface ReImportSpecification {
    /**
     * 
     * @type {Sensor}
     * @memberof ReImportSpecification
     */
    sensorWrapper: Sensor;
    /**
     * 
     * @type {GeneratorExternalKey}
     * @memberof ReImportSpecification
     */
    generatorExternalKey: GeneratorExternalKey;
    /**
     * 
     * @type {string}
     * @memberof ReImportSpecification
     */
    dataProviderKey: string;
    /**
     * 
     * @type {string}
     * @memberof ReImportSpecification
     */
    resolution: string;
    /**
     * 
     * @type {string}
     * @memberof ReImportSpecification
     */
    intervalName: string;
    /**
     * 
     * @type {number}
     * @memberof ReImportSpecification
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof ReImportSpecification
     */
    timeTo: number;
}

/**
 * Check if a given object implements the ReImportSpecification interface.
 */
export function instanceOfReImportSpecification(value: object): value is ReImportSpecification {
    if (!('sensorWrapper' in value) || value['sensorWrapper'] === undefined) return false;
    if (!('generatorExternalKey' in value) || value['generatorExternalKey'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('intervalName' in value) || value['intervalName'] === undefined) return false;
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    return true;
}

export function ReImportSpecificationFromJSON(json: any): ReImportSpecification {
    return ReImportSpecificationFromJSONTyped(json, false);
}

export function ReImportSpecificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReImportSpecification {
    if (json == null) {
        return json;
    }
    return {
        
        'sensorWrapper': SensorFromJSON(json['sensorWrapper']),
        'generatorExternalKey': GeneratorExternalKeyFromJSON(json['generatorExternalKey']),
        'dataProviderKey': json['dataProviderKey'],
        'resolution': json['resolution'],
        'intervalName': json['intervalName'],
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
    };
}

export function ReImportSpecificationToJSON(json: any): ReImportSpecification {
    return ReImportSpecificationToJSONTyped(json, false);
}

export function ReImportSpecificationToJSONTyped(value?: ReImportSpecification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sensorWrapper': SensorToJSON(value['sensorWrapper']),
        'generatorExternalKey': GeneratorExternalKeyToJSON(value['generatorExternalKey']),
        'dataProviderKey': value['dataProviderKey'],
        'resolution': value['resolution'],
        'intervalName': value['intervalName'],
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
    };
}

